import React from 'react'

import { Dismiss } from 'flowbite'

class DismissTarget extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { targetId, onDismiss } = this.props

    const $targetEl = document.getElementById(targetId)

    const $triggerEl = document.getElementById(`close-${targetId}`)

    const options = {
      transition: 'transition-opacity',
      duration: 1000,
      timing: 'ease-out'
    }

    const instanceOptions = {
      id: targetId,
      override: true
    }

    new Dismiss($targetEl, $triggerEl, options, instanceOptions)

    if (onDismiss && $triggerEl) {
      $triggerEl.addEventListener('click', () => {
        setTimeout(onDismiss, options.duration)
      })
    }
  }

  render() {
    const { targetId, iconColor, iconSize } = this.props

    return (
      <button id={`close-${targetId}`} type='button' className='inline-flex items-center justify-center h-4 w-4' data-dismiss-target={targetId} aria-label='Close'>
        <span className='sr-only'>Dismiss</span>
        <hero-icon-solid name='x' class={`flex-shrink-0 aspect-square ${iconColor || 'text-base-gray-main'} ${iconSize || 'w-4 h-4'}`}></hero-icon-solid>
      </button>
    )
  }
}

export default DismissTarget
